/**
 * UpgradeButton component.
 */
import Button from '@components/atoms/buttons/upgradeButton';
import Props from '@shared/types/props/pressable';
import useButton from './useButton';

/**
 * Displays the upgrade button with the given text and action.
 */
export default function UpgradeButton(parentProps: Props) {
  const { callbacks, props, buttonText } = useButton(parentProps);
  return (
    <Button {...props} {...callbacks} id='upgradeButton'>
      {buttonText}
    </Button>
  );
}
